function validaString(setRetorno, tamanho, valor) {
    if (valor.length <= tamanho) {
        if (valor.length === 1 && valor === ' ') {
            return;
        }
        let regexString = /^[\w\s\báàâãéèêíïóôõöúçÁÀÂÃÉÈÍÏÓÔÕÖÚÇ()%\-,.\/;:=]+$/;
        if(regexString.test(valor) || valor === ''){
            setRetorno(valor);
        }
        
    }
}


export default validaString;